export const CITIES = [
  // Asia - Pacific
  { name: "Manila", timezone: "Asia/Manila", country: "PH" },
  { name: "Tokyo", timezone: "Asia/Tokyo", country: "JP" },
  { name: "Osaka", timezone: "Asia/Tokyo", country: "JP" },
  { name: "Seoul", timezone: "Asia/Seoul", country: "KR" },
  { name: "Busan", timezone: "Asia/Seoul", country: "KR" },
  { name: "Singapore", timezone: "Asia/Singapore", country: "SG" },
  { name: "Bangkok", timezone: "Asia/Bangkok", country: "TH" },
  { name: "Jakarta", timezone: "Asia/Jakarta", country: "ID" },
  { name: "Bali", timezone: "Asia/Makassar", country: "ID" },
  { name: "Hong Kong", timezone: "Asia/Hong_Kong", country: "HK" },
  { name: "Macau", timezone: "Asia/Macau", country: "MO" },
  { name: "Shanghai", timezone: "Asia/Shanghai", country: "CN" },
  { name: "Beijing", timezone: "Asia/Shanghai", country: "CN" },
  { name: "Taipei", timezone: "Asia/Taipei", country: "TW" },
  { name: "Kaohsiung", timezone: "Asia/Taipei", country: "TW" },
  { name: "Kuala Lumpur", timezone: "Asia/Kuala_Lumpur", country: "MY" },
  { name: "Ho Chi Minh", timezone: "Asia/Ho_Chi_Minh", country: "VN" },
  { name: "Hanoi", timezone: "Asia/Bangkok", country: "VN" },
  { name: "Phnom Penh", timezone: "Asia/Phnom_Penh", country: "KH" },
  { name: "Yangon", timezone: "Asia/Rangoon", country: "MM" },
  { name: "Colombo", timezone: "Asia/Colombo", country: "LK" },
  { name: "Dhaka", timezone: "Asia/Dhaka", country: "BD" },
  { name: "Kathmandu", timezone: "Asia/Kathmandu", country: "NP" },
  { name: "Mumbai", timezone: "Asia/Kolkata", country: "IN" },
  { name: "New Delhi", timezone: "Asia/Kolkata", country: "IN" },
  { name: "Bangalore", timezone: "Asia/Kolkata", country: "IN" },
  { name: "Chennai", timezone: "Asia/Kolkata", country: "IN" },
  { name: "Karachi", timezone: "Asia/Karachi", country: "PK" },
  { name: "Islamabad", timezone: "Asia/Karachi", country: "PK" },
  { name: "Kabul", timezone: "Asia/Kabul", country: "AF" },
  { name: "Tashkent", timezone: "Asia/Tashkent", country: "UZ" },
  { name: "Almaty", timezone: "Asia/Almaty", country: "KZ" },
  // Oceania
  { name: "Sydney", timezone: "Australia/Sydney", country: "AU" },
  { name: "Melbourne", timezone: "Australia/Melbourne", country: "AU" },
  { name: "Brisbane", timezone: "Australia/Brisbane", country: "AU" },
  { name: "Perth", timezone: "Australia/Perth", country: "AU" },
  { name: "Auckland", timezone: "Pacific/Auckland", country: "NZ" },
  { name: "Honolulu", timezone: "Pacific/Honolulu", country: "US" },
  { name: "Fiji", timezone: "Pacific/Fiji", country: "FJ" },
  // Middle East
  { name: "Dubai", timezone: "Asia/Dubai", country: "AE" },
  { name: "Abu Dhabi", timezone: "Asia/Dubai", country: "AE" },
  { name: "Riyadh", timezone: "Asia/Riyadh", country: "SA" },
  { name: "Doha", timezone: "Asia/Qatar", country: "QA" },
  { name: "Kuwait City", timezone: "Asia/Kuwait", country: "KW" },
  { name: "Muscat", timezone: "Asia/Muscat", country: "OM" },
  { name: "Beirut", timezone: "Asia/Beirut", country: "LB" },
  { name: "Tel Aviv", timezone: "Asia/Jerusalem", country: "IL" },
  { name: "Amman", timezone: "Asia/Amman", country: "JO" },
  { name: "Baghdad", timezone: "Asia/Baghdad", country: "IQ" },
  { name: "Tehran", timezone: "Asia/Tehran", country: "IR" },
  // Europe
  { name: "London", timezone: "Europe/London", country: "GB" },
  { name: "Dublin", timezone: "Europe/Dublin", country: "IE" },
  { name: "Lisbon", timezone: "Europe/Lisbon", country: "PT" },
  { name: "Madrid", timezone: "Europe/Madrid", country: "ES" },
  { name: "Barcelona", timezone: "Europe/Madrid", country: "ES" },
  { name: "Paris", timezone: "Europe/Paris", country: "FR" },
  { name: "Brussels", timezone: "Europe/Brussels", country: "BE" },
  { name: "Amsterdam", timezone: "Europe/Amsterdam", country: "NL" },
  { name: "Berlin", timezone: "Europe/Berlin", country: "DE" },
  { name: "Frankfurt", timezone: "Europe/Berlin", country: "DE" },
  { name: "Munich", timezone: "Europe/Berlin", country: "DE" },
  { name: "Zurich", timezone: "Europe/Zurich", country: "CH" },
  { name: "Vienna", timezone: "Europe/Vienna", country: "AT" },
  { name: "Rome", timezone: "Europe/Rome", country: "IT" },
  { name: "Milan", timezone: "Europe/Rome", country: "IT" },
  { name: "Prague", timezone: "Europe/Prague", country: "CZ" },
  { name: "Warsaw", timezone: "Europe/Warsaw", country: "PL" },
  { name: "Budapest", timezone: "Europe/Budapest", country: "HU" },
  { name: "Bucharest", timezone: "Europe/Bucharest", country: "RO" },
  { name: "Athens", timezone: "Europe/Athens", country: "GR" },
  { name: "Istanbul", timezone: "Europe/Istanbul", country: "TR" },
  { name: "Helsinki", timezone: "Europe/Helsinki", country: "FI" },
  { name: "Stockholm", timezone: "Europe/Stockholm", country: "SE" },
  { name: "Oslo", timezone: "Europe/Oslo", country: "NO" },
  { name: "Copenhagen", timezone: "Europe/Copenhagen", country: "DK" },
  { name: "Moscow", timezone: "Europe/Moscow", country: "RU" },
  { name: "St. Petersburg", timezone: "Europe/Moscow", country: "RU" },
  { name: "Kyiv", timezone: "Europe/Kiev", country: "UA" },
  // Africa
  { name: "Cairo", timezone: "Africa/Cairo", country: "EG" },
  { name: "Casablanca", timezone: "Africa/Casablanca", country: "MA" },
  { name: "Lagos", timezone: "Africa/Lagos", country: "NG" },
  { name: "Accra", timezone: "Africa/Accra", country: "GH" },
  { name: "Nairobi", timezone: "Africa/Nairobi", country: "KE" },
  { name: "Addis Ababa", timezone: "Africa/Addis_Ababa", country: "ET" },
  { name: "Johannesburg", timezone: "Africa/Johannesburg", country: "ZA" },
  { name: "Cape Town", timezone: "Africa/Johannesburg", country: "ZA" },
  { name: "Dar es Salaam", timezone: "Africa/Dar_es_Salaam", country: "TZ" },
  { name: "Kigali", timezone: "Africa/Kigali", country: "RW" },
  // Americas
  { name: "New York", timezone: "America/New_York", country: "US" },
  { name: "Boston", timezone: "America/New_York", country: "US" },
  { name: "Miami", timezone: "America/New_York", country: "US" },
  { name: "Washington DC", timezone: "America/New_York", country: "US" },
  { name: "Atlanta", timezone: "America/New_York", country: "US" },
  { name: "Chicago", timezone: "America/Chicago", country: "US" },
  { name: "Dallas", timezone: "America/Chicago", country: "US" },
  { name: "Houston", timezone: "America/Chicago", country: "US" },
  { name: "Denver", timezone: "America/Denver", country: "US" },
  { name: "Phoenix", timezone: "America/Phoenix", country: "US" },
  { name: "Los Angeles", timezone: "America/Los_Angeles", country: "US" },
  { name: "San Francisco", timezone: "America/Los_Angeles", country: "US" },
  { name: "Seattle", timezone: "America/Los_Angeles", country: "US" },
  { name: "Las Vegas", timezone: "America/Los_Angeles", country: "US" },
  { name: "Anchorage", timezone: "America/Anchorage", country: "US" },
  { name: "Toronto", timezone: "America/Toronto", country: "CA" },
  { name: "Montreal", timezone: "America/Toronto", country: "CA" },
  { name: "Vancouver", timezone: "America/Vancouver", country: "CA" },
  { name: "Mexico City", timezone: "America/Mexico_City", country: "MX" },
  { name: "Cancún", timezone: "America/Cancun", country: "MX" },
  { name: "Guatemala City", timezone: "America/Guatemala", country: "GT" },
  { name: "Panama City", timezone: "America/Panama", country: "PA" },
  { name: "Bogotá", timezone: "America/Bogota", country: "CO" },
  { name: "Lima", timezone: "America/Lima", country: "PE" },
  { name: "Caracas", timezone: "America/Caracas", country: "VE" },
  { name: "São Paulo", timezone: "America/Sao_Paulo", country: "BR" },
  { name: "Rio de Janeiro", timezone: "America/Sao_Paulo", country: "BR" },
  { name: "Brasília", timezone: "America/Sao_Paulo", country: "BR" },
  { name: "Buenos Aires", timezone: "America/Argentina/Buenos_Aires", country: "AR" },
  { name: "Santiago", timezone: "America/Santiago", country: "CL" },
];